<template>
  <el-container class="home">
    <el-header class="my-header" style="font-size: 14px">
      <span class="m-l-10" style="color: #409EFF">Захиалгын жагсаалт</span>
      <div class="flr">
        <span class="m-r-10" prob="first_name">{{ user.name }}</span>
      </div>
    </el-header>
    <el-row class="m-t-60">
      <el-col :span="22" :offset="1">
        <el-row :gutter="20" type="flex" class="m-t-10" justify="space-around">
          <el-col :span="12" class="cursor">
            <div class="schedule_detail_count p-10" @click="chooseComponent(130)">
              Нийт хувиарлагдсан <br />
              <span style="color:#281C9D">{{ deliveryProcess }}</span>
            </div>
          </el-col>

          <el-col :span="12" class="cursor">
            <div class="schedule_detail_count" @click="chooseComponent(200)">
              Нийт хүргэсэн<br />
              <span style="color:green">{{ deliveryDone }}</span>
            </div>
          </el-col>
        </el-row>
      </el-col>
          <el-col :span="22" class="m-l-10">
            <DeliveryComponent :progressCode="progress_code" @reloadCounFUnction="getCountDataByDriver"/>
          </el-col>
    </el-row>
  </el-container>
</template>

<script>
import DeliveryComponent from '@/components/DeliveryComponent.vue'
import { mapGetters } from 'vuex'
import services from '@/helpers/services.js'

export default {
  computed: {
    ...mapGetters({
      user: 'userGetter'
    })
  },
  data () {
    return {
      token: JSON.parse(localStorage.getItem('idToken')),
      deliveryList: [],
      progress_code: 130,
      deliveryDone: 0,
      deliveryProcess: 0
    }
  },
  components: {
    DeliveryComponent
  },
  created () {
    this.getCountDataByDriver()
  },
  methods: {
    getCountDataByDriver () {
      this.$root.fullscreenLoading = true
      services.getCountDataByDriver()
        .then(response => {
          if (response.type === 'success') {
            this.deliveryDone = response.deliveryDone
            this.deliveryProcess = response.deliveryProcess
          }
          this.$root.fullscreenLoading = false
        }).catch((err) => {
          console.log(err)
          this.$root.fullscreenLoading = false
        })
    },
    chooseComponent (data) {
      this.progress_code = data
    },
    returnStatusValue (data) {
      const result = this.$root.statusArray.find(element => element.value === data)
      return result ? result.label : 'empty'
    },
    goToOrderDetail (data) {
      this.$store.dispatch('addOrderDetail', data)
      this.$router.push({ name: 'orderDetail', params: { passData: data } })
    }
  }
}
</script>

<style>
.el-header {
  background-color: white;
  color: #5EC7CA;
  font-weight: bolder;
  font-size: 20px;
  line-height: 60px;
  padding: 0px;
  padding-right: 40px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  position: relative;
  width: 100%;
  left: 0;
  top: 0;
}
</style>
